import { FuelTypeOutputWithStatus } from './fuel-type-output-with-status.model';


export class FuelTypeSelectByIdOutput implements IFuelTypeSelectByIdOutput {
    status!: number;
    message!: string;
    data!: FuelTypeOutputWithStatus;

    constructor(data?: IFuelTypeSelectByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? FuelTypeOutputWithStatus.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FuelTypeSelectByIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new FuelTypeSelectByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IFuelTypeSelectByIdOutput {
    status: number;
    message: string;
    data: FuelTypeOutputWithStatus;
}

